import API from './api';

export const getAdvertisements = async (deviceToken) => {
    try {
        const response = await API.get('/api/v1/advertisements/all', {
            headers: {
                'Device-Token': deviceToken,
            },
        });
        return response.data;
    } catch (error) {
        throw error; // Ошибка будет обработана в action
    }
};

export const postAdvertisementPlay = async (advertisementId, deviceToken) => {
    try {
        const response = await API.post(
            '/api/v1/advertisements/plays/',
            { advertisement_id: advertisementId },
            {
                headers: {
                    'Device-Token': deviceToken,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};